
  function showPrev(event) {
    var el = $(event.target);
    // console.log(el);
    var elW = $(el).innerWidth();
    var wiW = $(document).innerWidth();
    var matchWidth = (wiW - elW) / 2;
    var posl = $(el).find('.owl-stage').position().left;
    // console.log(Math.abs(posl));
    var currentItem = event.item.index;
    $(el).find('.owl-stage .owl-item').removeClass('current')
    $(el).find('.owl-stage .owl-item').eq(currentItem).addClass('current');
    if (matchWidth < Math.abs(posl)) {
      $(el).find('.owl-prev').addClass('show');
    } else {
      $(el).find('.owl-prev').removeClass('show');
    }
  };

  function currentItem(event) {
    var el = $(event.target);
    // console.log(el);
    var currentItem = event.item.index;
    $(el).find('.owl-stage .owl-item').removeClass('current')
    $(el).find('.owl-stage .owl-item').eq(currentItem).addClass('current');
  };

  function currentOnHover(event) {
    var el = $(event.target);
    $(el).find('.owl-stage .owl-item').on('mouseover', function (e) {
      $(el).find('.owl-stage .owl-item').removeClass('current');
      if ($(this).is('.currentOnHover')) return;
      $(el).find('.owl-stage .owl-item').removeClass('currentOnHover');
      $(this).addClass('currentOnHover');
    })
  };

  $('#bt-slider').owlCarousel({
    loop: true,
    nav: false,
    dots: true,
    lazyLoad: true,
    dotsEach: 1,
    items: 1
  });

  $('#popular-slides').owlCarousel({
    nav: false,
    dots: false,
    items: 6,
    margin: 23,
    autoWidth: true,
    loop:true,
    navText: [
      "<img src='" + assetBaseUrl + "images/arrow-navy-blue.svg'>",
      "<img src='" + assetBaseUrl + "images/arrow-navy-blue.svg'>"
    ],
    responsive: {
      0: {
        items: 1.2
      },
      1025: {
        items: 3.5,
        nav: true
      }
    },
    onTranslated: showPrev,
    onDraged: showPrev,
    onInitialized: currentItem,
    onRefresh: currentOnHover
  });


  $('#amaze-slides,#cruise').owlCarousel({
    nav: false,
    dots: false,
    items: 6,
    margin: 23,
    autoWidth: true,
    navText: [
      "<img src='" + assetBaseUrl + "images/arrow-white.svg'>",
      "<img src='" + assetBaseUrl + "images/arrow-white.svg'>"
    ],
    responsive: {
      0: {
        items: 1.2
      },
      1024: {
        items: 3.5,
        nav: true
      }
    },
    onTranslated: showPrev,
    onDrage: showPrev,
    onInitialized: currentItem,
    onRefresh: currentOnHover
  });

  $('#thumb360').owlCarousel({
    nav: false,
    dots: false,
    items: 2,
    margin: 24,
    autoWidth: true,
    navText: [
      "<img src='" + assetBaseUrl + "images/banner-arrow.svg'>",
      "<img src='" + assetBaseUrl + "images/banner-arrow.svg'>"
    ],
    responsive: {
      0: {
        items: 3.2
      },
      600: {
        items: 4.5
      }
    },
    onTranslated: currentItem,
    onDrage: currentItem,
    onInitialized: currentItem,
    onRefresh: currentOnHover
  });

  $('#complimentary-offers').owlCarousel({
    nav: false,
    dots: false,
    items: 6,
    margin: 24,
    autoWidth: true,
    navText: [
      "<img src='" + assetBaseUrl + "images/arrow-navy-blue.svg'>",
      "<img src='" + assetBaseUrl + "images/arrow-navy-blue.svg'>"
    ],
    responsive: {
      0: {
        items: 1.2
      },
      1025: {
        items: 3.5,
        nav: true
      }
    },
    onTranslated: showPrev,
    onDraged: showPrev,
    onInitialized: currentItem,
    onRefresh: currentOnHover
  });

  $("#res-exp-slider,#review-slider").owlCarousel({
    nav: false,
    dots: false,
    items: 6,
    margin: 23,
    autoWidth: true,
    navText: [
      "<img src='" + assetBaseUrl + "images/arrow-navy-blue.svg'>",
      "<img src='" + assetBaseUrl + "images/arrow-navy-blue.svg'>"
    ],
    responsive: {
      0: {
        items: 1.2
      },
      1025: {
        items: 3.5,
        nav: true
      }
    },
    onTranslated: showPrev,
    onDraged: showPrev,
    onInitialized: currentItem,
    onRefresh: currentOnHover
  });

  $("#reso-video-slider").owlCarousel({
    nav: false,
    dots: false,
    items: 6,
    margin: 23,
    autoWidth: true,
    navText: [
      "<img src='" + assetBaseUrl + "images/arrow-navy-blue.svg'>",
      "<img src='" + assetBaseUrl + "images/arrow-navy-blue.svg'>"
    ],
    responsive: {
      0: {
        items: 1.2
      },
      1025: {
        nav: true
      }
    },
    onTranslated: showPrev,
    onDraged: showPrev,
    onInitialized: currentItem,
    onRefresh: currentOnHover
  });

  $("#offer-sel-slider").owlCarousel({
    nav: false,
    dots: false,
    items: 1.5,
    margin: 23,
    autoWidth: true,
    navText: [
      "<img src='" + assetBaseUrl + "images/arrow-navy-blue.svg'>",
      "<img src='" + assetBaseUrl + "images/arrow-navy-blue.svg'>"
    ],
    responsive: {
      0: {
        items: 1.2
      },
      1025: {
        nav: true
      }
    },
    onTranslated: showPrev,
    onDraged: showPrev,
    onInitialized: currentItem,
    onRefresh: currentOnHover
  });



  $("#plan-sel-slider").owlCarousel({
    nav: false,
    dots: false,
    items: 1.5,
    margin: 23,
    autoWidth: true,
    navText: [
      "<img src='" + assetBaseUrl + "images/arrow-navy-blue.svg'>",
      "<img src='" + assetBaseUrl + "images/arrow-navy-blue.svg'>"
    ],
    responsive: {
      0: {
        items: 1.2
      },
      1025: {
        nav: true
      }
    },
    onTranslated: showPrev,
    onDraged: showPrev,
    onInitialized: currentItem,
    onRefresh: currentOnHover
  });

  $('[id*="slides"]').owlCarousel({
    nav: false,
    dots: false,
    items: 6,
    margin: 23,
    autoWidth: true,
    navText: [
      "<img src='" + assetBaseUrl + "images/arrow-navy-blue.svg'>",
      "<img src='" + assetBaseUrl + "images/arrow-navy-blue.svg'>"
    ],
    responsive: {
      0: {
        items: 1.2
      },
      1025: {
        items: 3.5,
        nav: true
      }
    },
    onTranslated: showPrev,
    onDraged: showPrev,
    onInitialized: currentItem,
    onRefresh: currentOnHover
  });


  /*Customised crousel*/

  $('#popular-resort-section').owlCarousel({
    nav: false,
    dots: false,
    items: 3,
    margin: 0,
    loop:true,
    navText: [
      "<img src='" + assetBaseUrl + "images/arrow-navy-blue.svg'>",
      "<img src='" + assetBaseUrl + "images/arrow-navy-blue.svg'>"
    ],
    responsive: {
      0: {
        items: 1,
        margin:10
      },
      790: {
        items: 2,
        nav: true,
        margin:10
      },
      950: {
        items: 2,
        nav: true
      },
      1025: {
        items: 3,
        nav: true
      },
      
    },
    // onTranslated: showPrev,
    // onDraged: showPrev,
    // onInitialized: currentItem,
    // onRefresh: currentOnHover
  });
  $('#popular-resort-section2').owlCarousel({
    nav: false,
    dots: false,
    items: 3,
    margin: 0,
    loop:true,
    navText: [
      "<img src='" + assetBaseUrl + "images/arrow-navy-blue.svg'>",
      "<img src='" + assetBaseUrl + "images/arrow-navy-blue.svg'>"
    ],
    responsive: {
      0: {
        items: 1,
        margin:10
      },
      790: {
        items: 2,
        nav: true,
        margin:10
      },
      950: {
        items: 2,
        nav: true
      },
      1025: {
        items: 3,
        nav: true
      },
      
    },
    // onTranslated: showPrev,
    // onDraged: showPrev,
    // onInitialized: currentItem,
    // onRefresh: currentOnHover
  });
  $('#attractions').owlCarousel({
    nav: true,
    dots: true,
    items: 1,
    margin: 10,
    loop:true,
    navText: [
      "<img src='" + assetBaseUrl + "images/gift-arrows.svg'>",
      "<img src='" + assetBaseUrl + "images/gift-arrows.svg'>"
    ],
    responsive: {
      0: {
        items: 1,
        margin:5
      },
      790: {
        items: 1,
        nav: true,
        margin:10
      },
      950: {
        items: 1,
        nav: true
      },
      1025: {
        items: 1,
        nav: true
      },
      
    },
   
  });

  
  $('#bigholidays').owlCarousel({
    loop:true,
    margin:0,
    nav:true,
    items:3,
    lazyLoad: true,
    autoplay:true,
    autoplaySpeed: 1000,
    navText: [
      "<img src='" + assetBaseUrl + "images/arrow-navy-blue.svg'>",
      "<img src='" + assetBaseUrl + "images/arrow-navy-blue.svg'>"
    ],
  responsive:{
        0:{
            items:1,
            margin:15,
        },
        800:{
            items:2,
        },
        1000:{
            items:3,
        },
        1400:{
            items:3,
        },
        1800:{
            items:3,
            nav:true  
        }
    }
});




//   $("#").owlCarousel({
//     nav: true,
//     dots: !1,
//     items: 3,
//     margin: 0,
//     loop:false,
//     navText: [
//       "<img src='" + assetBaseUrl + "images/arrow-navy-blue.svg'>",
//       "<img src='" + assetBaseUrl + "images/arrow-navy-blue.svg'>"
//     ],
//     responsive: { 0: { items: 1.05,margin:15 }, 1025: { items: 3, nav: true } },
// })

$('.callback_form input,.callback_form select').click(function () {
  $(this).parent().addClass('moveup');
});

  $(function () {
    var landingSlider = $('.landing-slider'),
      landingSliderOwlOptions = {
        nav: false,
        dots: false,
        items: 3,
        margin: 23,
        autoWidth: true,
        navText: [
          "<img src='" + assetBaseUrl + "images/arrow-navy-blue.svg'>",
          "<img src='" + assetBaseUrl + "images/arrow-navy-blue.svg'>"
        ],
        responsive: {
          0: {
            items: 1.2
          },
          1025: {
            items: 3,
            nav: true,
          }
        },
        onTranslated: showPrev,
        onDraged: showPrev,
        onInitialized: currentItem,
        onRefresh: currentOnHover
      };

    if ($(window).width() > 767) {
      landingSlider.owlCarousel(landingSliderOwlOptions);
    } else {
      landingSlider.addClass('off');
    }
  });